import { ApiTerminateInsuranceReasonCodeResponseInterface, TerminateInsuranceReasonCodeInterface } from '../interfaces';

export function mapTerminateReasonCodeRequest(
    response: ApiTerminateInsuranceReasonCodeResponseInterface,
): TerminateInsuranceReasonCodeInterface[] {
    return response?.reden_codes?.map((code) => ({
        reasonCode: code.reason_code,
        reasonTitle: code.reason_title,
        reasonComment: code.reason_comment,
        maximumEndDate: code.maximum_end_date ? subtractOneDay(code.maximum_end_date) : code.maximum_end_date,
        minimumEndDate: code.minimum_end_date ? subtractOneDay(code.minimum_end_date) : code.minimum_end_date,
    }));
}

function subtractOneDay(date: string): string {
   const currentDate = new Date(date);
   currentDate.setUTCDate(currentDate.getUTCDate() - 1);
   return currentDate.toISOString().split('T')[0];
}
